import { useMediaHandler } from "../../hooks/useMediaHandler";

const Audio = ({ fileUrl, attachment, onError }) => {
  const { mediaRef, handleError } = useMediaHandler({ src: fileUrl, onError });

  return (
    <div>
      <audio
        ref={mediaRef}
        controls
        className="audio-player"
        preload="metadata"
      >
        <source
          src={fileUrl}
          type={attachment.content_type}
          onError={handleError}
        />
        Your browser does not support the audio element.
      </audio>
    </div>
  );
};
export default Audio;
